import createWidgetFactory from "../../_js/widget_utils";

import staticWidgetCfg from "../config.json";
import widgetComponent from "./component";
import state from "./state";
import heightLimiter from "./heightlimiter";


const Trellis = createWidgetFactory(staticWidgetCfg, function (widget, cfg) {
    /* Example overloading: * /
     var _defaultDestroy = widget.destroy;
     widget.destroy = function () {
     _defaultDestroy.call(widget);
     // do more...
     };
     /**/

    // widget.defaultStrings = require('../i18n/en.js');

    widget.state = state(widget, {
        forecastId: cfg.forecast,
        forecastTypeId: cfg.forecast_type,
    });
    widget.mainComponent = widgetComponent(widget);

    widget.dataGridWidth = staticWidgetCfg.dataGridWidth;
    widget.maxZoom = staticWidgetCfg.maxZoom;


    widget = heightLimiter(widget);

});

export default Trellis;
